import React, { useState } from "react";
import classNames from "classnames";

import ReloadSvg from "@components/icons/reload-svg";
import SettingsSvg from "@components/icons/settings-svg";
import Progress from "@components/progress/progress";

import { useAppSelector } from "@hooks/use-store";

type PropsTypeProgressPanel = {
  onClickSettings?: () => void;
  onClickReload?: () => void;
};

function ProgressPanel({
  onClickSettings,
  onClickReload,
}: PropsTypeProgressPanel) {
  const { progress } = useAppSelector((state) => state.app);

  const [animationRotate, setAnimationRotate] = useState(false);

  const reload = () => {
    setAnimationRotate(true);
    if (onClickReload) onClickReload();
    setTimeout(function () {
      setAnimationRotate(false);
    }, 300);
  };

  return (
    <div className='mx-auto mt-5 mb-5 flex max-w-[19.35rem] items-center justify-between px-3 md:mt-0 md:mb-6'>
      <button
        onClick={reload}
        type='button'
        className={classNames("m-lg", {
          "rotate-360 transition duration-300 ease-in-out": animationRotate,
        })}
      >
        <ReloadSvg
          classNameProps='text-icon-primary dark:text-icon-dark-primary'
          width={30}
          height={30}
        />
      </button>
      <Progress
        widthProgress='w-[11.25rem]'
        colorProgressBar='bg-bg-secondary dark:bg-bg-dark-secondary'
        colorProgressValue='bg-green dark:bg-green-dark-default'
        progress={progress}
        progressActive={0}
      />
      <button
        id='tutor_settings_btn'
        onClick={onClickSettings}
        type='button'
        className='m-lg'
      >
        <SettingsSvg
          classNameProps='fill-current text-icon-primary dark:text-icon-dark-primary'
          width={30}
          height={30}
        />
      </button>
    </div>
  );
}

export default ProgressPanel;
